export enum ResourceExamesEnum {
  EXAME_LABORATORIAIS = "Exame Laboratorial",
  ECOGRAFIA = "Ecografia",
  TOMOGRAFIA = "Tomografia",
  RESSONANCIA_MAGNETICA = "Ressonância Magnética",
  RAIO_X = "Raio-X",
  MAMOGRAFIA = "Mamografia",
  ELETROCARDIOGRAMA_REPOUSO = "Eletrocardiograma em Repouso",
  ELETROENCEFALOGRAMA = "Eletroencefalograma",
  ESPIROMETRIA = "Espirometria",
  VIDEO_NASOFIBROSCOPIA = "Vídeo Nasofibroscopia",
  VIDEO_ENDOSCOPIA_NASOSSINUSAL = "Vídeo Endoscopia Nasossinusal",
  MAPA = "MAPA",
  TESTE_ERGOMETRICO = "Teste Ergométrico",
  ENDOSCOPIA_COLONOSCOPIA = "Endoscopia/Colonoscopia",
  POLISSONOGRAFIA = "Polissonografia",
  AUDIOMETRIAS = "Audiometrias",
  CINTILOGRAFIA = "Cintilografia",
  GENETICA = "Genética",
  ANATOMOPATOLOGICO = "Anatomopatológico",
  PET_SCAN = "PET Scan",
}

export enum ResourceTerapiaEnum {
  HEMODIALISE = "Hemodiálise",
  QUIMIOTERAPIA = "Quimioterapia",
  RADIOTERAPIA = "Radioterapia",
}

export enum GroupFaq {
  PLATAFORMA = "Sobre a Plataforma",
  USUARIO = "Perfis de Usuário",
  SEGURANCA = "Documentação e Segurança",
  FUNCIONALIDADES = "Funcionalidades",
  PAGAMENTOS = "Planos e Pagamentos",
  TECNICO = "Aspectos Técnicos",
}

export enum ProductTypeEnumDescription {
 
  SUBSCRIPTION_PROVIDER_PF_FREE = "Pacote basico para profissionais pessoa física",
  SUBSCRIPTION_PROVIDER_PF_BASIC = "Pacote completo para profissionais pessoa física - Starter",

  SUBSCRIPTION_LAB_FREE = "Pacote básico para laboratórios",
  SUBSCRIPTION_LAB_BASIC = "Pacote completo para laboratórios - Basic",
  SUBSCRIPTION_LAB_PERSONAL = "Pacote personalizado para laboratórios",

  SUBSCRIPTION_PROVIDER_PJ_FREE = "Pacote básico para empresas prestadoras",
  SUBSCRIPTION_PROVIDER_PJ_2 = "Pacote para empresas prestadoras com até 2 Profissionais",
  SUBSCRIPTION_PROVIDER_PJ_6 = "Pacote para empresas prestadoras com até 6 Profissionais",
  SUBSCRIPTION_PROVIDER_PJ_10 = "Pacote para empresas prestadoras com até 10 Profissionais",
  SUBSCRIPTION_PROVIDER_PJ_PERSONAL = "Pacote para empresas prestadoras com mais de 10 Profissionais",

  SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE = "Pacote híbrido básico para empresas",
  SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100 = "Pacote híbrido para empresas com até 100 conexoes",
  SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL = "Pacote híbrido personalizado para empresas",

  SUBSCRIPTION_CONTRACTOR_PJ_120 = "Pacote para empresas contratantes com até 120 conexoes",
  SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL = "Pacote personalizado para empresas contratantes ",

  SUBSCRIPTION_ADMINISTRATOR = "Pacote para administradores e mantenedotas  da rede"

}
